import React from 'react';
import { useDispatch } from 'react-redux';
import { externalFile } from 'hellospa/page/prep-and-send/data/actions/file';
import {
  EvernoteIntegration, UploadIntegrationType, ExternalFileContents,
} from 'hellospa/page/prep-and-send/data/types/integration';
import CustomPicker from './custom-picker';
import ReAuthModal from './reauth-modal';
import evernoteIcon from 'images/external_logo_med_E.png';

type Props = {
  settings: EvernoteIntegration,
  shouldTriggerPicker: boolean,
  toggleIntegrationPicker: (integration: string, status: boolean) => void,
}

export default function EvernoteFilePicker({
  settings,
  shouldTriggerPicker,
  toggleIntegrationPicker,
}: Props) {
  const dispatch = useDispatch();

  const onClose = React.useCallback(() => {
    toggleIntegrationPicker(UploadIntegrationType.Evernote, false);
  }, [toggleIntegrationPicker]);

  const onFileSelect = React.useCallback((file: ExternalFileContents) => () => {
    dispatch(externalFile(UploadIntegrationType.Evernote, file.id, file.name));
    // toggle the modal
    onClose();
  }, [dispatch, onClose]);

  // if clicked on the integration icon but it's not enabled,
  // trigger the modal to initiate auth
  if (shouldTriggerPicker && !settings.enabled) {
    return (
      <ReAuthModal
        integration={UploadIntegrationType.Evernote}
        integrationIcon={evernoteIcon}
        isOpen={shouldTriggerPicker && !settings.enabled}
        onClose={onClose} />
    );
  }

  // return null if it hasn't been triggered or enabled
  if (!shouldTriggerPicker || !settings.enabled) {
    return null;
  }

  return (
    <CustomPicker
      integration={UploadIntegrationType.Evernote}
      isOpen={shouldTriggerPicker && settings.enabled}
      integrationIcon={evernoteIcon}
      onFileSelect={onFileSelect}
      onClose={onClose} />
  );
}
